<template>
  <section id="projects" class="projects-container">
    <h2>Projects</h2>
    <div class="project-list">
      <div
        v-for="(project, index) in projects"
        :key="index"
        class="project-card"
      >
        <div class="project-header">
          <h3>{{ project.title }}</h3>
          <p class="project-subtitle">{{ project.subtitle }}</p>
        </div>

        <div class="project-body">
          <div class="project-section">
            <h4>🚀 My Role & Key Contributions</h4>
            <ul>
              <li v-for="(contribution, i) in project.contributions" :key="i">
                {{ contribution }}
              </li>
            </ul>
          </div>

          <div class="project-section">
            <h4>💡 Motivation</h4>
            <p>{{ project.motivation }}</p>
          </div>

          <div class="project-section">
            <h4>🛠️ Tech Stack</h4>
            <div class="tags">
              <span v-for="(tech, i) in project.stack" :key="i" class="tag">{{
                tech
              }}</span>
            </div>
          </div>
        </div>

        <div class="project-footer">
          <a
            v-if="project.github"
            :href="project.github"
            target="_blank"
            class="link-btn"
            >GitHub</a
          >
          <a
            v-if="project.figma"
            :href="project.figma"
            target="_blank"
            class="link-btn"
            >Figma</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProjectsSection",
  data() {
    return {
      projects: [
        {
          title: "Fund:ing - AI 기반 차세대 핀테크 펀딩 플랫폼",
          subtitle: "Spring Legacy, Vue.js, OpenAI API",
          motivation:
            "AI 기술을 접목해 복잡한 금융 상품을 사용자 친화적으로 재해석하고, 게이미피케이션 요소를 통해 재미와 의미를 더하는 새로운 펀딩 플랫폼을 구축했습니다.",
          role: "Full-Stack Developer",
          contributions: [
            "OpenAI(GPT-4o, Vision) API를 활용한 AI 기능 전체 설계 및 개발 (펀딩 추천, 설명, 이미지 자동 검증)",
            "관리자 및 창작자를 위한 대시보드(대출 관리, 챌린지 검증)의 View 및 API 전체 구현",
            "Docker 기반 배포 환경 구성 및 Swagger를 활용한 API 문서 자동화",
            "Spring Security와 JWT를 사용한 인증/인가 시스템 설계 및 구현",
          ],
          stack: [
            "Spring Framework",
            "MyBatis",
            "Vue 3",
            "Pinia",
            "OpenAI API",
            "AWS S3",
            "MySQL",
            "Docker",
            "Swagger",
          ],
          github: "https://github.com/Jejudo-Ticket/server",
        },
        {
          title: "EducationClass - 온라인 교육 관리 플랫폼",
          subtitle: "Spring Boot, JPA, WebRTC",
          motivation:
            "비대면 교육 환경의 한계를 극복하고 강사와 수강생 간의 상호작용을 강화하기 위해, 실시간 소통 기능이 포함된 강력한 백엔드 시스템을 직접 설계하고 개발했습니다.",
          role: "Backend Developer",
          contributions: [
            "서비스에 필요한 모든 API의 설계부터 구현까지 100% 담당",
            "STOMP와 WebRTC를 활용하여 실시간 채팅 및 화상 강의 기능 구축",
            "GitHub Actions를 이용한 CI/CD 파이프라인을 구축하여 배포 자동화",
            "AWS 인프라(EC2, RDS, Route53) 설계 및 구축, SSL 인증서를 적용하여 HTTPS 배포 완료",
          ],
          stack: [
            "Spring Boot",
            "Spring Security",
            "JPA",
            "QueryDSL",
            "WebRTC",
            "STOMP",
            "MySQL",
            "AWS",
          ],
          github: "https://github.com/kimdavid0521/EducationClassProject",
        },
        {
          title: "디닥토 (DIDACTO) - 실시간 원격 제어 강의 플랫폼",
          subtitle: "Spring Boot, WebSocket, Redis",
          motivation:
            "기존의 일방적인 온라인 강의의 한계를 넘어, 강사가 학생의 화면을 직접 제어하며 소통하는 양방향 코딩 교육 환경을 제공하기 위해 기획했습니다.",
          role: "Backend Developer",
          contributions: [
            "WebSocket을 활용하여 강사가 학생 PC를 원격 제어하는 핵심 기능 개발",
            "PortOne(아임포트) API를 연동하여 강의 등록 및 수강을 위한 결제 시스템 구축",
            "Redis를 도입하여 최근 검색어 관리 및 검색 성능 최적화",
            "강의 생성/참여 및 중복 참여 방지를 위한 다대다 관계 로직 설계 및 구현",
          ],
          stack: [
            "Spring Boot",
            "JPA",
            "WebSocket",
            "Redis",
            "PortOne",
            "MySQL",
            "AWS",
          ],
          github: "https://github.com/orgs/DIDACTO-SMU/repositories", // 여기에 링크를 입력하세요
        },
        {
          title: "majorLink - 대학생 전공 상호 멘토링 플랫폼",
          subtitle: "Spring Boot, WebRTC, Iamport",
          motivation:
            "전공 선택에 대한 고민과 새로운 분야 탐색의 어려움이라는 대학생들의 Pain Point를 해결하기 위해, 전공 지식을 교환하고 소통할 수 있는 멘토링 플랫폼을 기획했습니다.",
          role: "Backend Developer",
          contributions: [
            "WebRTC와 Google STUN 서버를 이용해 NAT 환경에서도 안정적인 실시간 화상 통화 기능 구현",
            "Iamport API를 연동하여 다양한 결제 수단을 지원하는 간편 결제 시스템 개발",
            "Docker와 GitHub Actions를 활용해 코드 변경 시 자동으로 서버에 반영되는 CI/CD 파이프라인 구축",
          ],
          stack: [
            "Spring Boot",
            "WebRTC",
            "STOMP",
            "Iamport",
            "AWS EC2",
            "Docker",
            "GitHub Actions",
          ],
          github: "https://github.com/orgs/TeamMajorLink/repositories",
        },
        {
          title: "ITer - IT 초보자를 위한 스마트 IT 서비스",
          subtitle: "React, TypeScript, React Query",
          motivation:
            "IT 제품 정보 과잉 속에서 소비자들이 겪는 혼란을 해결하고자, 전문가 리뷰와 퀴즈를 결합하여 신뢰도 높은 정보와 재미를 함께 제공하는 서비스를 개발했습니다.",
          role: "Frontend Developer",
          contributions: [
            "React Query를 활용하여 데이터 Fetching 및 서버 상태 관리 로직을 최적화",
            "TypeScript를 프로젝트에 도입하여 코드 안정성과 유지보수성을 향상",
            "Vite 기반의 개발 환경에서 리뷰 작성/조회 등 핵심 UI 및 기능 구현",
            "ESLint와 Prettier를 통한 코드 컨벤션 설정 및 코드 품질 관리",
          ],
          stack: [
            "React",
            "TypeScript",
            "Vite",
            "React Query",
            "React Router",
            "Vercel",
          ],
          github: "https://github.com/BETTER-iTER",
        },
        {
          title: "AI English Teacher - ChatGPT API 활용 영어 학습 서비스",
          subtitle: "React, ChatGPT API",
          motivation:
            "전통적인 영어 학습의 한계를 넘어, AI를 통해 개인화된 실시간 피드백을 제공하는 맞춤형 학습 경험을 만들고자 프로젝트를 시작했습니다.",
          role: "Frontend Developer",
          contributions: [
            "ChatGPT API와의 비동기 통신 로직을 구현하여 AI와 사용자 간의 실시간 채팅 기능 개발",
            "다양한 디바이스에 대응하는 반응형 UI를 설계하여 학습 접근성 향상",
            "사용자 입력 및 AI 응답에 따른 상태 관리 및 에러 처리 로직 구현",
          ],
          stack: ["React", "ChatGPT API", "JavaScript(ES6+)", "CSS3"],
          github: "https://github.com/orgs/4th-umc-hackathon/repositories",
        },
      ],
    };
  },
};
</script>
<style scoped>
.projects-container {
  padding: 100px 5%;
  background-color: var(--bg-color);
}
h2 {
  font-size: 2.5rem;
  margin-bottom: 50px;
  text-align: center;
}
.project-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  max-width: 900px;
  margin: 0 auto;
}
.project-card {
  background: var(--bg-secondary-color);
  border: 1px solid var(--card-border-color);
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}
.project-card:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 30px var(--card-shadow-color);
  border-color: var(--point-color);
}
.project-header {
  border-bottom: 1px solid var(--card-border-color);
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.project-header h3 {
  font-size: 1.8rem;
  margin: 0;
  color: var(--text-primary-color);
}
.project-subtitle {
  font-family: "Fira Code", monospace;
  color: var(--text-secondary-color);
  margin: 10px 0 0 0;
}
.project-body {
  flex-grow: 1;
}
.project-section {
  margin-bottom: 25px;
}
.project-section h4 {
  font-size: 1.1rem;
  color: var(--text-primary-color);
  margin-bottom: 10px;
}
.project-section p {
  color: var(--text-secondary-color);
  line-height: 1.7;
  margin: 0;
}
.project-section ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.project-section li {
  color: var(--text-secondary-color);
  line-height: 1.7;
  padding-left: 20px;
  position: relative;
  margin-bottom: 5px;
}
.project-section li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--point-color);
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.tag {
  background-color: var(--tag-bg-color);
  color: var(--point-color);
  padding: 5px 12px;
  border-radius: 5px;
  font-size: 0.85rem;
  font-family: "Fira Code", monospace;
}
.project-footer {
  margin-top: 20px;
  display: flex;
  gap: 15px;
}
.link-btn {
  color: var(--point-color);
  text-decoration: none;
  border: 1px solid var(--link-border-color);
  padding: 8px 15px;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-weight: 500;
}
.link-btn:hover {
  background-color: var(--link-hover-bg-color);
  color: var(--link-hover-text-color);
  border-color: var(--link-hover-bg-color);
}

@media (max-width: 768px) {
  .projects-container {
    padding: 60px 5%;
  }
}
</style>
